import { render } from "./OrdersScreen.vue?vue&type=template&id=68f577ee&scoped=true"
import script from "./OrdersScreen.vue?vue&type=script&lang=js"
export * from "./OrdersScreen.vue?vue&type=script&lang=js"

import "./OrdersScreen.vue?vue&type=style&index=0&id=68f577ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f577ee"]])

export default __exports__